<template>
  <div>
    <div class="panel" style="margin-left: 1em">
      <h3 class="panel-header">
        Create New {{ $resident({ capitalize: true }) }}
      </h3>
      <div class="panel-content-container">
        <div
          class="patient-form"
          v-if="$store.state.user?.role?.permissions?.includes('can_do_resident')"
        >
          <div class="patient-form-navigation">
            <div
              v-if="!creatingPatient || newPatientFinished"
              class="patient-form-image-container"
            >
              <img :src="previewImage" class="uploading-image" />
              <div
                v-if="!previewImage"
                style="
                  height: 250px;
                  display: flex;
                  border-radius: 8px;
                  flex-direction: column;
                  align-items: center;
                  justify-content: space-around;
                  background-color: #f3f4f4;
                "
              >
                <i
                  class="pi pi-user"
                  style="font-size: 5em !important; color: #d8dcdc"
                ></i>
                <p>
                  {{ $resident({ capitalize: true }) }} photo to display here
                </p>
              </div>
              <label
                for="patient-image-upload"
                class="image-file-upload"
                style="
                  width: 100%;
                  margin: 0 auto;
                  padding: 5px 10px;
                  border-radius: 4px;
                  cursor: pointer;
                  color: white;
                  background-color: #0870dc;
                "
                v-html="
                  previewImage
                    ? 'Change Image'
                    : 'Upload ' + $resident({ capitalize: true }) + ' Image'
                "
              >
              </label>
              <input
                type="file"
                id="patient-image-upload"
                accept="image/jpeg,image/png"
                @change="uploadImage"
                style="display: none"
              />
            </div>
            <!-- <div v-else class="patient-form-image-container">
                            <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 10px;"></i>
                        </div> -->
          </div>
          <div
            v-if="!creatingPatient || newPatientFinished"
            class="patient-form-content"
          >
            <div class="patient-form-content-section">
              <PatientCoreFields
                :personalInformation="personalInformation"
                :regulatoryNumbers="regulatory_numbers"
                :ihiDetails="ihiDetails"
                :facilities="facilities"
                :nodes="nodes"
                :selectedFacility="selectedFacility"
                :selectedNodeKey="selectedNodeKey"
                @update:personalInformation="personalInformation = $event"
                @update:regulatoryNumbers="regulatory_numbers = $event"
                @update:ihiDetails="ihiDetails = $event"
                @update:selectedFacility="selectedFacility = $event"
                @update:selectedNodeKey="selectedNodeKey = $event"
                :loadingLocations="loadingLocations"
                :isSimplified="isSimplified"
                :similarSoundingName="similar_sounding_name"
                @facility-change="retrieveSelectedFacilityLocations()"
              />
              <!-- Create button -->
              <div>
                <div
                  class="field-checkbox"
                  style="display: flex; margin-top: 2em"
                >
                  <Checkbox :binary="true" v-model="aslr_site_consent" />
                  <label
                    style="
                      font-size: 1em;
                      padding-left: 10px;
                      font-weight: bold;
                    "
                    for="binary"
                    >{{ $resident({ capitalize: true }) }} consents to
                    healthcare provider view access of their Active Script List
                    (if they are registered).</label
                  >
                </div>
                <p
                  :class="requiredDetails ? 'blue-button' : 'grey-button'"
                  @click="requiredDetails && createPatient()"
                  style="
                    margin: 1em 1em 1em 0em;
                    padding: 8px 20px;
                    width: fit-content;
                    font-weight: bold;
                  "
                >
                  Create {{ $resident({ capitalize: true }) }}
                </p>
              </div>
            </div>
          </div>
          <div v-else class="patient-form-image-container">
            <i
              class="pi pi-spin pi-spinner"
              style="font-size: 2rem !important; margin-top: 10px"
            ></i>
          </div>
        </div>

        <div v-else style="margin-top: 10em">
          <h3
            style="
              border: 2px solid black;
              border-bottom: 2px solid black;
              width: fit-content;
              margin: 0 auto;
              padding: 5px;
              border-radius: 4px;
            "
          >
            You do not have permission to access this feature. Please talk to
            your admin if you require access.
          </h3>
        </div>
      </div>
    </div>
    <NewResdidentModal
      @close="resetView"
      @proceed="proceed"
      v-if="newPatientFinished"
      :stages="stages"
    />
    <SuccessModal
      @close="close"
      v-if="displaySuccessModal"
      :message="errMessage"
    />
    <IHIHistoryModal
      v-if="displayIHIHistoryModal"
      @close="close"
      :patientID="patientUUID"
    />
    <IHIConflictModal
      v-if="displayIHIConflictModal"
      @close="close"
      :personalInformation="personalInformation"
      :conflictPatients="
        ihiDetails.conflicts && ihiDetails.conflicts.length
          ? ihiDetails.conflicts
          : ''
      "
    />
    <ConfirmationModal
      v-if="displayFacilityWarningModal"
      :actionDescription="facilityWarningMessage"
      acceptText="Continue"
      rejectText="Cancel"
      @close="displayFacilityWarningModal = false"
      @accepted="confirmCreatePatient"
    />
    <ConfirmationModal
      v-if="displaySimilarNameModal"
      :actionDescription="similarNameWarningMessage"
      acceptText="Submit"
      rejectText="Cancel"
      @close="onSimilarNameModalCancelled"
      @accepted="onSimilarNameModalAccepted"
    />
  </div>
</template>

<script>
import axios from "axios";
import NewResdidentModal from "@/components/modals/NewResidentModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import IHIHistoryModal from "@/components/modals/IHIHistoryModal.vue";
import IHIConflictModal from "@/components/modals/IHIConflictModal.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import PatientCoreFields from "@/components/patientViewComponents/PatientCoreFields.vue";
import {
  buildRegulatoryPayload,
  emptyRegulatoryNumbers,
  extractLocationUuid,
  formatDobForSubmit,
  hasRequiredPatientDetails,
  isSimplifiedOnboarding,
} from "@/services/patientValidation";

export default {
  components: {
    NewResdidentModal,
    SuccessModal,
    IHIHistoryModal,
    IHIConflictModal,
    ConfirmationModal,
    PatientCoreFields,
  },
  data() {
    return {
      minExpiryDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1,
      ),
      creatingPatient: false,
      bundleSuccess: false,
      loadingLocations: false,
      patientStatusFinished: false,
      regulatoryFinished: false,
      imageUploadFinished: false,
      errMessage: "",
      displaySuccessModal: false,
      displayIHIHistoryModal: false,
      displayIHIConflictModal: false,
      patientUUID: "",
      personalInformation: {
        first_name: "",
        last_name: "",
        preferred_name: "",
        tag: [],
        sex: "",
        dob: "",
      },
      aslr_site_consent: false,
      similar_sounding_name: false,
      displaySimilarNameModal: false,
      similarNameWarningMessage: "",
      pendingPatientPayload: null,
      regulatory_numbers: emptyRegulatoryNumbers(),
      facility_location: {
        room_uuid: "",
      },
      // LOCATION DETAILS
      parentLocation: "",
      nodes: [],
      selectedNodeKey: null,
      selectedFacility: null,
      facilities: [],
      locationName: "",
      childLocations: [],
      previewImage: null,
      pharmacies: "",
      selectedPharmacy: "",
      prescribers: "",
      selectedPrescriber: "",
      ihiDetails: {
        number: "",
        ihi_status: "",
        ihi_record_status: "",
        conflicts: [],
      },
      displayFacilityWarningModal: false,
      stages: [],
    };
  },
  methods: {
    checkSimilarNames() {
      if (
        !this.personalInformation.first_name ||
        !this.personalInformation.last_name
      ) {
        return Promise.resolve([]);
      }

      const facilityUuid =
        this.selectedFacility?.value ||
        this.$store.state.currentLocation?.facility?.uuid;
      if (!facilityUuid) return Promise.resolve([]);

      return axios
        .post(
          `/facility/${facilityUuid}/similar-sounding-names`,
          {
            first_name: this.personalInformation.first_name,
            last_name: this.personalInformation.last_name,
          },
          this.$store.state.header,
        )
        .then((res) => {
          let matches = [];
          if (Array.isArray(res.data)) {
            matches = res.data;
          } else if (res.data && typeof res.data === "object") {
            matches = Object.values(res.data);
          }

          if (matches.length > 0) {
            this.similar_sounding_name = true;
          }

          return matches;
        })
        .catch((err) => {
          console.error("Failed to check similar sounding names", err);
          return [];
        });
    },
    checkDuplicateRegulatoryNumbers() {
      const facilityUuid =
        this.selectedFacility?.value ||
        this.$store.state.currentLocation?.facility?.uuid;
      const medicareNumber = this.regulatory_numbers.medicare_number.number;
      const ihiNumber = this.ihiDetails.number;
      if (!facilityUuid || (!medicareNumber && !ihiNumber)) {
        return Promise.resolve([]);
      }

      return axios
        .post(
          `/facility/${facilityUuid}/check-duplicate-regulatory-numbers`,
          {
            medicare_number: medicareNumber,
            ihi_number: ihiNumber,
          },
          this.$store.state.header,
        )
        .then((res) => {
          return Array.isArray(res.data) ? res.data : [];
        })
        .catch((err) => {
          console.error("Failed to check duplicate regulatory numbers", err);
          return [];
        });
    },
    buildSimilarNameWarningMessage() {
      return `This ${this.$resident()}'s name sounds similar to another resident.`;
    },
    buildDuplicateRegulatoryWarningMessage(matches) {
      const types = [...new Set(matches.map((m) => m.regulatory_type))];
      const list = types.join(" and ");
      const verb = types.length > 1 ? "already belong" : "already belongs";
      return `The ${list} entered ${verb} to another resident.`;
    },
    buildCombinedWarningMessage(reasons) {
      const bullets = reasons.map((reason) => `• ${reason}`).join("\n");
      return `Do you want to continue saving?\n\n${bullets}`;
    },
    onSimilarNameModalAccepted() {
      this.displaySimilarNameModal = false;
      this.submitNewPatientBundle(this.pendingPatientPayload);
    },
    onSimilarNameModalCancelled() {
      this.displaySimilarNameModal = false;
      this.creatingPatient = false;
    },
    createPatient() {
      // Check if selected facility differs from the user's current facility
      const currentFacilityUuid =
        this.$store.state.currentLocation?.facility?.uuid;
      const selectedFacilityUuid = this.selectedFacility?.value;
      if (
        currentFacilityUuid &&
        selectedFacilityUuid &&
        currentFacilityUuid !== selectedFacilityUuid
      ) {
        this.displayFacilityWarningModal = true;
        return;
      }
      this.confirmCreatePatient();
    },
    confirmCreatePatient() {
      this.displayFacilityWarningModal = false;
      this.creatingPatient = true;
      let personalPayload = { ...this.personalInformation };

      // Handle selectedNodeKey - TreeSelect returns an object like {"uuid": true}, we need just the uuid string
      if (this.selectedNodeKey) {
        personalPayload.location = extractLocationUuid(this.selectedNodeKey);
      } else {
        // If no location selected, show error and return
        this.displaySuccessModal = true;
        this.creatingPatient = false;
        this.errMessage =
          "Please select a location for the " + this.$resident() + ".";
        return;
      }

      if (this.personalInformation.dob) {
        personalPayload.dob = formatDobForSubmit(this.personalInformation.dob);
      }

      if (this.aslr_site_consent) {
        console.log("HITTING THE ASLR SITE CONSENT CONDITION", personalPayload);
        personalPayload.tag.push("aslr_site_consent");
      }

      Promise.all([
        this.checkSimilarNames(),
        this.checkDuplicateRegulatoryNumbers(),
      ]).then(([similarNameMatches, duplicateRegulatoryMatches]) => {
        // Add similar_sounding_name boolean to payload
        personalPayload.similar_sounding_name = this.similar_sounding_name;

        const reasons = [];
        if (similarNameMatches && similarNameMatches.length > 0) {
          reasons.push(this.buildSimilarNameWarningMessage());
        }
        if (
          duplicateRegulatoryMatches &&
          duplicateRegulatoryMatches.length > 0
        ) {
          reasons.push(
            this.buildDuplicateRegulatoryWarningMessage(
              duplicateRegulatoryMatches,
            ),
          );
        }

        if (reasons.length > 0) {
          this.pendingPatientPayload = personalPayload;
          this.similarNameWarningMessage =
            this.buildCombinedWarningMessage(reasons);
          this.displaySimilarNameModal = true;
          return;
        }

        this.submitNewPatientBundle(personalPayload);
      });
    },
    submitNewPatientBundle(personalPayload) {
      if (!this.patientUUID) {
        return axios
          .post("/person/bundle", personalPayload, this.$store.state.header)
          .then((res) => {
            this.bundleSuccess = true;
            this.stages.push(
              "General " +
                this.$resident({ capitalize: true }) +
                " Information saved",
            );
            console.log("patient registered.");
            this.patientUUID = res.data.uuid;
            axios
              .post(
                `/person/${this.patientUUID}/status`,
                { status: "onboarding" },
                this.$store.state.header,
              )
              .then((res) => {
                this.patientStatusFinished = true;
                // this.stages.push(" Patient status saved")
              })
              .catch((err) => {
                this.patientStatusFinished = true;
                // this.stages.push(" Patient Status save failed: " + err.response.data)
                this.successMessage = `Error: ${err.response.data}`;
              });
            this.submitRegulatoryInfo();
            this.submitImage();
            // Validate IHI after successful patient creation
            this.validateIHIAfterCreation();
          })
          .catch((err) => {
            // Display failure because bundle is the only required endpoint for generation. The rest can be added on later.
            this.displaySuccessModal = true;
            this.creatingPatient = false;
            this.errMessage =
              "General " +
              this.$resident({ capitalize: true }) +
              " Information save failed: " +
              err.response.data;
          });
      }
    },
    // IHI Validation Methods
    validateIHIAfterCreation() {
      // Only validate IHI if eprescribing is active and IHI number is provided
      if (
        !this.$store.state.user.eprescribing_active ||
        !this.ihiDetails.number
      ) {
        return;
      }

      let payload = {};

      // Check if we have Medicare number
      if (this.regulatory_numbers.medicare_number.number) {
        const cleanMedicareNumber =
          this.regulatory_numbers.medicare_number.number.split(" ").join("");
        payload = {
          type: "medicare",
          number: cleanMedicareNumber,
          patient_id: this.patientUUID,
        };
      } else if (this.regulatory_numbers.dva_number.number) {
        // Check if we have DVA number
        const cleanDVANumber = this.regulatory_numbers.dva_number.number
          .split(" ")
          .join("");
        payload = {
          type: "dva",
          number: cleanDVANumber,
          patient_id: this.patientUUID,
        };
      } else if (this.ihiDetails.number) {
        // Use IHI number directly
        const cleanIHINumber = this.ihiDetails.number.split(" ").join("");
        payload = {
          type: "ihi",
          number: cleanIHINumber,
          patient_id: this.patientUUID,
        };
      } else {
        console.log("No number available for IHI validation");
        return;
      }

      axios
        .post("/validate-ihi", payload, this.$store.state.header)
        .then((response) => {
          console.log("IHI validation successful:", response.data);
          this.validIHI(response);
        })
        .catch((err) => {
          console.log("IHI validation failed:", err, err.response);
          // Check if the response is resolved but for a different IHI
          if (
            err.response &&
            err.response.data &&
            err.response.data.error &&
            err.response.data.error.includes("duplicate")
          ) {
            console.log(
              "Resolved and different IHI number returned",
              err.response.data.data,
            );
            payload = {
              type: "ihi",
              number: err.response.data.data.ihi_number,
              patient_id: this.patientUUID,
            };
            axios
              .post("/validate-ihi", payload, this.$store.state.header)
              .then((response) => {
                console.log("Second IHI validation successful:", response.data);
                this.validIHI(response);
              })
              .catch((err) => {
                this.invalidIHI(err);
              });
          } else {
            this.invalidIHI(err);
          }
        });
    },
    validIHI(response) {
      this.ihiDetails = response.data.data;
      // Update IHI details in the backend
      axios
        .post(`/person/${this.patientUUID}/ihi`, {}, this.$store.state.header)
        .then((res) => {
          console.log("IHI details updated:", res.data);
          this.ihiDetails = res.data;
          if (res.data.conflicted) {
            this.displayIHIConflictModal = true;
          }
        })
        .catch((err) => {
          console.log("Error updating IHI details:", err);
        });
    },
    invalidIHI(err) {
      if (!err?.response?.data?.error?.includes("unique")) {
        this.ihiDetails.number = "";
        this.ihiDetails.ihi_record_status = "";
        this.ihiDetails.ihi_status = "";
      }

      // Show error message but don't block the patient creation process
      console.log("IHI validation failed:", err.response?.data);
      // You can optionally show a success modal with IHI validation warning
      // this.displaySuccessModal = true;
      // this.errMessage = "Patient created successfully, but IHI validation failed. Please check the IHI number and try again later.";
    },
    retrieveSelectedFacilityLocations() {
      this.loadingLocations = true;
      this.selectedNodeKey = null; // Reset the selected location when facility changes
      console.log("this is the selected facility", this.selectedFacility);

      if (!this.selectedFacility || !this.selectedFacility.value) {
        this.loadingLocations = false;
        return;
      }

      axios
        .post(
          `/facility/${this.selectedFacility.value}/locations`,
          {},
          this.$store.state.header,
        )
        .then((res) => {
          console.log("these are the facilities locations", res.data);
          this.$store.dispatch("getRefreshToken");
          this.nodes = Array.isArray(res.data) ? res.data : [];
          if (this.nodes.length > 0) {
            this.nodes.forEach((node) => {
              node.label = node.name;
              if (node.children && node.children.length) {
                this.getChildLocation(node);
              }
            });
          }
          this.loadingLocations = false;
        })
        .catch((err) => {
          console.log("Error retrieving facility locations:", err);
          this.loadingLocations = false;
        });
    },
    getFacilities() {
      this.$store.dispatch("getRefreshToken");
      axios
        .post("/get-facilities", {}, this.$store.state.header)
        .then((res) => {
          this.facilities = Array.isArray(res.data) ? res.data : [];
        })
        .catch((err) => {
          console.log("err issss", typeof err.response?.data);
          if (
            err.response &&
            err.response.data &&
            err.response.data.split(" ").includes("expired")
          ) {
            console.log("yes, it does include expired");
            this.$router.push("/login");
          }
          console.log("err is", err.response.data, err.response.data);
        });
    },
    resetView() {
      location.reload();
    },
    close() {
      this.displaySuccessModal = false;
      this.displayIHIHistoryModal = false;
      this.displayIHIConflictModal = false;
    },
    proceed() {
      this.$router.push({
        path: "/patient/" + this.patientUUID + "/patient_info",
        query: { subtab: "prescriber_details" },
      });
      this.displaySuccessModal = false;
    },
    // UPLOAD IMAGE
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    getLocations() {
      // currentLocation is still null on a cold load of this page, which threw
      // out of mounted() before the fallback below could be used.
      let facilityID =
        this.$store.state.currentLocation?.facility?.uuid ||
        "175f2a90-b5f8-4079-8ea0-07367b0c2db8";
      axios
        .post(`/facility/${facilityID}/locations`, {}, this.$store.state.header)
        .then((res) => {
          console.log("this is the facility location", res);
          this.$store.dispatch("getRefreshToken");
          this.nodes = Array.isArray(res.data) ? res.data : [];
          if (this.nodes.length > 0) {
            this.nodes.forEach((node) => {
              node.label = node.name;
              if (node.children && node.children.length) {
                this.getChildLocation(node);
              }
            });
          }
        })
        .catch((err) => {
          console.log("Error retrieving locations:", err);
        });
    },
    getChildLocation(location) {
      console.log("GET CHILD LOCATION LOOPING", location);
      location.label = location.name;
      if (location.children && location.children.length) {
        location.children.forEach((child) => {
          this.getChildLocation(child);
        });
      }
    },
    // SUBMIT IMAGE
    submitImage() {
      if (this.previewImage) {
        this.uploadingImage = true;
        axios
          .post(
            `/aws/patient/${this.patientUUID}/image`,
            {
              image: this.previewImage,
              item: ["profile", "thumbnail"],
            },
            this.$store.state.header,
          )
          .then((res) => {
            this.uploadingImage = false;
            this.imageUploadFinished = true;
            this.stages.push(
              this.$resident({ capitalize: true }) + " image saved",
            );
            console.log("uploaded patient image", res);
          })
          .catch((err) => {
            this.imageUploadFinished = true;
            this.stages.push(
              this.$resident({ capitalize: true }) +
                " Image save failed: " +
                err.response.data,
            );
            console.log(
              "this is the image upload error",
              err,
              err.response.data,
            );
          });
      } else {
        this.imageUploadFinished = true;
        console.log("No image has been uploaded");
      }
    },
    // REGULATORY INFO
    submitRegulatoryInfo() {
      const regulatory_numbers = buildRegulatoryPayload(this.regulatory_numbers);
      if (regulatory_numbers.length) {
        this.$store.dispatch("getRefreshToken");
        axios
          .post(
            `/person/${this.patientUUID}/regulatory`,
            { regulatory_numbers: regulatory_numbers },
            this.$store.state.header,
          )
          .then((res) => {
            this.regulatoryFinished = true;
            this.stages.push("Regulatory infomation saved");
            console.log("regulatory information submitted.", res);
          })
          .catch((err) => {
            this.regulatoryFinished = true;
            this.stages.push(
              "Regulatory information save failed: " + err.response.data,
            );
            console.log("this is the reg info error", err, err.response.data);
          });
      } else {
        this.regulatoryFinished = true;
        console.log("no regulatory numbers filled in or submitted.");
      }
    },

    selectChildLocation() {
      if (this.selectedNodeKey && typeof this.selectedNodeKey === "string") {
        this.facility_location.room_uuid = this.selectedNodeKey;
      } else if (
        this.selectedNodeKey &&
        typeof this.selectedNodeKey === "object" &&
        this.selectedNodeKey.key
      ) {
        this.facility_location.room_uuid = this.selectedNodeKey.key;
      }
    },
    // ON PAGE LOAD
    getLocationTree() {
      // clear out old error messages
      this.second_spec_line = "";
      this.errActions = "";

      axios
        .post(
          `/location/${this.$store.state.uuid}/simple-tree`,
          {},
          this.$store.state.header,
        )
        .then((res) => {
          this.parentLocation = res.data.parent_location_name;
          this.locationName = res.data.name;
          this.childLocations = res.data.child_locations;
        });
    },
  },
  mounted() {
    this.getLocationTree();
    this.getLocations();
    this.getFacilities();
  },
  watch: {
    selectedNodeKey(newVal, oldVal) {
      // Prevent infinite re-renders by checking if the value actually changed
      if (newVal !== oldVal) {
        console.log("selectedNodeKey changed:", newVal);
        console.log("selectedNodeKey type:", typeof newVal);
        console.log("selectedNodeKey value:", newVal);
        if (typeof newVal === "object") {
          console.log("selectedNodeKey object keys:", Object.keys(newVal));
        }
      }
    },
  },
  computed: {
    facilityWarningMessage() {
      const currentName =
        this.$store.state.currentLocation?.facility?.name ||
        "your current facility";
      const selectedName =
        this.selectedFacility?.label ||
        this.selectedFacility?.name ||
        "the selected facility";
      return `You are currently logged into "${currentName}" but are creating a ${this.$resident()} in "${selectedName}".\n\nDo you want to continue?`;
    },
    isSimplified() {
      return isSimplifiedOnboarding(this.$store);
    },
    requiredDetails() {
      return hasRequiredPatientDetails({
        personalInformation: this.personalInformation,
        regulatoryNumbers: this.regulatory_numbers,
        hasLocation: !!this.selectedNodeKey,
        isSimplified: this.isSimplified,
      });
    },
    newPatientFinished() {
      return (
        this.bundleSuccess &&
        this.patientStatusFinished &&
        this.regulatoryFinished &&
        this.imageUploadFinished
      );
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

#monthpicker {
  border-radius: 12px;

  input.p-inputtext {
    background-color: #f3f4f4 !important;
  }
}

.selected-navigation-item {
  width: 5px;
  height: 45px;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  margin-right: 5px;
  background-color: $strongblue;
}

.form-fields {
  display: flex;
  flex-wrap: wrap;
}

.form-field {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  margin-right: 20px;
  margin-top: 15px;

  label {
    padding-left: 10px;
  }

  input,
  label {
    display: block;
  }
}

.text-field {
  width: 20em;
}

.date-field {
  width: 20em;
}

.address-field {
  width: 12em;
}

.special-considerations-form {
  background-color: $grey;
  padding: 10px;
  border-radius: 8px;
}

.spec-cons-items {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.spec-cons-item {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.vac-weight-table {
  max-height: 300px;
  overflow-y: scroll;
}

// .form-control{
//     width: 20em;
// }

.prescriber-info-form-content {
  h3 {
    margin-top: 12px;
  }
}

#monthpicker {
  background-color: #f3f4f4 !important;
}
</style>
